import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router';
import { Theme } from '../../config/theme.js';

import FACEBOOK_ICON from './facebook.png';
import TWITTER_ICON from './twitter.png';
import INSTAGRAM_ICON from './instagram.png';
import LINK_ICON from './link.png';
import EMAIL_ICON from './email.png';

export default class SearchButton extends Component {
  render() {
    let social_icon = null;
    let link_style = null;
    let link_url = '';

    switch (this.props.type) {
      default:
        social_icon = FACEBOOK_ICON;
        link_style = styles.facebook;
        link_url = 'https://www.facebook.com/sniffersmag/';
        break;

      case 'facebook':
        social_icon = FACEBOOK_ICON;
        link_style = styles.facebook;
        link_url = 'https://www.facebook.com/sniffersmag/';
        break;

      case 'twitter':
        social_icon = TWITTER_ICON;
        link_style = styles.twitter;
        link_url = 'https://www.twitter.com/sniffersmag/';
        break;

      case 'instagram':
        social_icon = INSTAGRAM_ICON;
        link_style = styles.instagram;
        link_url = 'https://www.instagram.com/sniffersmag/';
        break;

      case 'email':
        social_icon = EMAIL_ICON;
        link_style = styles.link;
        break;
    }

    return (
      <a className={css(styles.container)} href={this.props.url ? this.props.url : link_url} target='_blank'>
        <img src={social_icon} className={css(styles.icon, link_style)} />
      </a>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    marginLeft: 30,
    height: 30,
    textAlign: 'center',
  },
  icon: {
    flex: 1,
    color: Theme.primary,
    ':hover': {
      opacity: 0.5,
    },
  },
  facebook: {
    width: 9,
    height: 20,
  },
  twitter: {
    width: 21,
    height: 17,
  },
  instagram: {
    width: 19,
    height: 19,
  },
  link: {
    marginTop: 2,
    width: 24,
    height: 17,
  },
})



// WEBPACK FOOTER //
// ./src/components/SocialLink/index.js